import Timestampable from '@/models/Timestampable'
import {
  PlantHarvestInterface,
  PlantHarvestDocInterface,
  id,
  dateOnly,
} from '@/types/models'
import { auth, serverTimestamp, firestoreTimestampToDate } from '@/firebase'
import Image from '@/models/Image'

import store from '@/store'
import Plant from './Plant'
import {
  DocumentData,
  QueryDocumentSnapshot,
  SnapshotOptions,
} from 'firebase/firestore'

export default class Harvest extends Timestampable {
  isNew = false
  plantId: id
  id: id
  date: dateOnly
  quantity: number
  quality: number // 1-5
  ripeness: number // 1-5
  size: number // 1-5
  traits: string[] // ['end rot', 'pest damage', 'etc...']
  note: string | null | undefined

  // images: Array<Image> = [];

  collections() {
    return {}
  }

  constructor(data: PlantHarvestInterface) {
    super(data)

    this.plantId = data.plantId
    this.id = data.id
    this.date = data.date
    this.quantity = data.quantity
    this.quality = data.quality
    this.ripeness = data.ripeness
    this.size = data.size
    this.traits = data.traits
    this.note = data.note

    this.isNew = data.isNew || false
  }

  get plant(): Plant {
    return store.getters['gardens/plants/find'](this.plantId)
  }

  get images(): Image[] {
    return store.getters['gardens/images/plantHarvestImages'](
      this.plant.gardenId,
      this.plantId,
      this.id
    )
    // return this.plant.images.filter((img: Image) => img.refs.includes(`gardens/${this.plant.gardenId}/plants/${this.plantId}/harvests/${this.id}`))
  }

  static fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
    plantId: id
  ): Harvest {
    const data = snapshot.data(options)

    const result: PlantHarvestInterface = {
      id: snapshot.id,
      plantId: plantId,
      date: data.date,
      quantity: data.quantity,
      quality: data.quality,
      ripeness: data.ripeness,
      size: data.size,
      traits: data.traits,
      note: data.note,

      createdBy: data.createdBy,
      createdAt: firestoreTimestampToDate(data.createdAt),
      updatedBy: data.updatedBy,
      updatedAt: firestoreTimestampToDate(data.updatedAt),

      isNew: false,
    }

    return new Harvest(result)
  }

  static firestoreConverter = (plantId: id) => ({
    toFirestore(harvest: Harvest): DocumentData {
      const h: PlantHarvestDocInterface = {
        // id: harvest.id,
        date: harvest.date,
        quantity: harvest.quantity,
        quality: harvest.quality,
        ripeness: harvest.ripeness,
        size: harvest.size,
        traits: harvest.traits,
        note: harvest.note,
      }

      if (harvest.isNew) {
        h.createdBy = auth.currentUser()?.uid
        h.createdAt = serverTimestamp()
      } else {
        h.updatedBy = auth.currentUser()?.uid
        h.updatedAt = serverTimestamp()
      }

      // console.log(h)

      return h
    },
    fromFirestore(
      snapshot: QueryDocumentSnapshot,
      options: SnapshotOptions
    ): Harvest {
      return Harvest.fromFirestore(snapshot, options, plantId)
    },
  })
}
